// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Face_style_b-icon-warning__Dnv4J","wrapper":"Face_style_wrapper__Oo5on","content":"Face_style_content__Cp7GM","rotate":"Face_style_rotate__EvMjZ"};